import React, {useState} from 'react';
import {Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tooltip} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import CloseIcon from "@material-ui/icons/Close";
import Button from "@material-ui/core/Button";
import {addUserRole, deleteUserRole} from "../../../actions";
import Select from "react-select";

const AdminUpdateUserRolesWidget = ({rolesArray=null,userId = null,})=>{

    const {users, loadingUsers, loadingUsersError, loadingAddUserRole, addUserRoleError, loadingDeleteUserRole, deleteUserRoleError} = useSelector(({users}) => users);
    const {customers} = useSelector(({customer}) => customer);

    const user = users && userId ? users[userId] : null;
    // const userRolesArray = user && Array.isArray(user.roles) && user.roles ? user.roles : [];

    const dispatch = useDispatch();
    const [openAddRole, setOpenAddRole] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [roleIdToDelete, setRoleIdToDelete] = useState(null);
    const [roleIdToAdd, setRoleIdToAdd] = useState(null);

    const handleConfirmDelete = () =>{
        console.log("handleConfirmDelete for user", userId, "deleting roleId", roleIdToDelete)
        dispatch(deleteUserRole({
            userId: userId,
            roleId: roleIdToDelete}))
        setOpenDelete(false);
    }

    const handleConfirmAdd = () =>{
        console.log("handleConfirmAdd for user", userId, "deleting roleId", roleIdToAdd)
        dispatch(addUserRole({
            userId: userId,
            roleId: roleIdToAdd}))
        setOpenAddRole(false);
    }

    let options = [
        {
            label: "staff",
            value: 1,
        },
        {
            label: "admin",
            value: 2,
        },
        {
            label: "customer",
            value: 3,
        },
        {
            label: "partner",
            value: 4,
        },
        {
            label: "breachrisk",
            value: 5,
        },
        {
            label: "breachrisk_portfolio",
            value: 6,
        },
    ]

    return(
        <div className="p-2 text-center">
                <span>
                    {!loadingAddUserRole[userId] && !addUserRoleError[userId]&&
                    <Button
                        variant={"contained"}
                        onClick={()=>setOpenAddRole(true)}
                        size={"small"}
                        > Add </Button>}
                    {!loadingDeleteUserRole[userId] && !deleteUserRoleError[userId]&&
                    <Button
                        variant={"contained"}
                        onClick={()=>setOpenDelete(true)}
                        size={"small"}
                        disabled={rolesArray && rolesArray.length < 1}> Delete </Button>}
                </span>

            {openDelete && <Dialog open={openDelete}
                    fullWidth={false}
                    maxWidth={"md"}
                    onClose={()=>setOpenDelete(false)}
                    className="form-dialog-title text-center">
                <DialogTitle >

                    <IconButton
                        onClick={()=>setOpenDelete(false)}
                        className={"close"}>
                        <CloseIcon/>
                    </IconButton>
                </DialogTitle>
                <DialogContent onClose={()=>setOpenDelete(false)}>
                    <div className={"col-12"} style={{height: "300px"}}>
                        <h3>Select a role type to delete for {user["username"]}. </h3>

                        <Select options={options}
                                labelId="addUserRoleSelect"
                                id="addUserRole"
                                name="addUserRole"
                                value={roleIdToDelete ? options.find(x => x.value === roleIdToDelete) : null}
                                defaultValue={roleIdToDelete ? options.find(x => x.value === roleIdToDelete) : options[0]}
                                onChange={(value)=> setRoleIdToDelete(value.value)}
                                className={"align-self-center m-0 p-0"}
                                isOptionDisabled={(option)=>{
                                    const arrRoleId = rolesArray.map((role)=>role.role.id);
                                    if(!arrRoleId.includes(option.value)){
                                        return true
                                    }
                                }}
                        />
                    </div>

                    <DialogActions>
                        <Button
                            variant={"contained"}
                            disabled={!roleIdToDelete}
                            onClick={()=> handleConfirmDelete()}>Confirm</Button>
                        <Button
                            variant={"contained"}
                            onClick={()=>setOpenDelete(false)}>Cancel</Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>}

            {openAddRole && <Dialog open={openAddRole}
                    fullWidth={false}
                    maxWidth={"md"}
                    onClose={()=>setOpenAddRole(false)}
                    className="form-dialog-title text-center">
                <DialogTitle >

                    <IconButton
                        onClick={()=>setOpenAddRole(false)}
                        className={"close"}>
                        <CloseIcon/>
                    </IconButton>
                </DialogTitle>
                <DialogContent onClose={()=>setOpenAddRole(false)}>
                    <div className={"col-12"} style={{height: "300px"}}>
                        <h3>Select a role type to add to {user["username"]}. </h3>

                        <Select options={options}
                                labelId="addUserRoleSelect"
                                id="addUserRole"
                                name="addUserRole"
                                value={roleIdToAdd ? options.find(x => x.value === roleIdToAdd) : null}
                                defaultValue={roleIdToAdd ? options.find(x => x.value === roleIdToAdd) : options[0]}
                                onChange={(value)=> setRoleIdToAdd(value.value)}
                                className={"align-self-center m-0 p-0"}
                                isOptionDisabled={(option)=>{
                                    const arrRoleId = rolesArray.map((role)=>role.role.id);
                                    if(arrRoleId.includes(option.value)){
                                        return true
                                    }
                                }}
                        />
                    </div>

                    <DialogActions>
                        <Button
                            variant={"contained"}
                            disabled={!roleIdToAdd}
                            onClick={()=> handleConfirmAdd()}>Confirm</Button>
                        <Button
                            variant={"contained"}
                            onClick={()=>setOpenAddRole(false)}>Cancel</Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>}


        </div>
    )
}

export default AdminUpdateUserRolesWidget;